// GENERATED FILE — do not edit by hand.
// Produced by scripts/generate-api-reference.js from payouts.api.external.yaml.
// Regenerate with `npm run generate:reference` after pulling a new spec, then commit the diff.

// Deliberately untyped (matches how the rest of the reference already treats GROUPS — see the
// (g: any) casts in guides.tsx/home.tsx/reference.tsx): endpoint shapes vary per-operation, and
// this data is generated + regenerated on every build rather than hand-maintained against a type.
export const GENERATED_GROUPS: any[] = [
  {
    "id": "entities",
    "label": "Entities",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-entities",
        "method": "GET",
        "path": "/v2/entities",
        "name": "List the authenticated partner's entities",
        "auth": "Partner key",
        "summary": "List the authenticated partner's entities",
        "queryParams": [
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Return only the entity whose `externalId` matches (your own id)."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Filter by metadata key/value pairs, e.g. `metadata[crmId]=C-1`. Matches entities whose metadata contains every supplied pair.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/entities",
          "resource": "entities",
          "action": "list",
          "args": []
        },
        "response": {
          "data": [
            {
              "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
              "type": "business",
              "externalId": "partner-biz-1234",
              "createdAt": "2026-07-08T15:00:00Z",
              "updatedAt": "2026-07-08T15:00:00Z",
              "name": "Acme Supplies",
              "legalName": "Acme Supplies LLC",
              "businessType": "llc",
              "taxInfo": {
                "type": "ein",
                "identifierLast4": "6789"
              },
              "phoneNumber": "+12125551234",
              "contact": {
                "firstName": "Jane",
                "lastName": "Doe"
              },
              "website": "https://acmesupplies.com",
              "address": {
                "line1": "350 5th Ave",
                "city": "New York",
                "state": "NY",
                "postalCode": "10118",
                "countryCode": "US"
              },
              "legalAddress": {
                "line1": "350 5th Ave",
                "city": "New York",
                "state": "NY",
                "postalCode": "10118",
                "countryCode": "US"
              },
              "industry": {
                "naicsCode": "424410"
              },
              "owner": {
                "firstName": "Jane",
                "lastName": "Doe",
                "email": "jane.doe@acmesupplies.com"
              }
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-entities",
        "method": "POST",
        "path": "/v2/entities",
        "name": "Create an entity",
        "auth": "Partner key",
        "badge": "Trusted",
        "summary": "Create an entity (untrusted partners may create one; trusted partners may create many)",
        "headerParams": [
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": false,
            "desc": "Unique key (recommended: a UUID) that makes a create request safe to retry. Retrying with the same key replays the original response instead of creating a second resource. Scoped per partner, retained 24h. Reusing a key with a different body returns 409.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed session token issued by the Melio Sonar SDK on the device that initiated the request. When present it is cryptographically verified and its device IP is used for risk evaluation; an invalid or expired token is rejected with 403. Omit it when no SDK session is available.\n"
          }
        ],
        "fields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": "Entity type discriminator. Only `business` is supported today."
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Partner's own id for the entity (unique per partner)"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "name",
            "type": "string",
            "required": true,
            "desc": "Company (doing-business-as) name. Between 3 and 100 characters."
          },
          {
            "name": "legalName",
            "type": "string",
            "required": true,
            "desc": "Full legal business name as it appears on the tax return. Between 3 and 100 characters."
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": true,
            "desc": "Business phone number. Must contain at least 9 digits."
          },
          {
            "name": "businessType",
            "type": "enum",
            "options": [
              "partnership",
              "sole-proprietorship",
              "llc",
              "corporation",
              "trust",
              "non-profit",
              "municipality"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "taxInfo.identifier",
            "type": "string",
            "required": true,
            "desc": "9-digit tax identifier, optionally dash-separated (e.g. 12-3456789)."
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n"
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state code (e.g. NY, CA)."
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n"
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state code (e.g. NY, CA)."
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.dateOfBirth",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "owner.phoneNumber",
            "type": "string",
            "required": false,
            "desc": "Optional. When supplied, must contain at least 9 digits."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/entities",
          "resource": "entities",
          "action": "create",
          "args": [],
          "body": {
            "type": "business",
            "externalId": "partner-biz-1234",
            "name": "Acme Supplies",
            "legalName": "Acme Supplies LLC",
            "phoneNumber": "+12125551234",
            "businessType": "llc",
            "taxInfo": {
              "type": "ein",
              "identifier": "12-3456789"
            },
            "industry": {
              "naicsCode": "424410"
            },
            "contact": {
              "firstName": "Jane",
              "lastName": "Doe"
            },
            "website": "https://acmesupplies.com",
            "address": {
              "line1": "350 5th Ave",
              "city": "New York",
              "state": "NY",
              "postalCode": "10118"
            },
            "legalAddress": {
              "line1": "350 5th Ave",
              "city": "New York",
              "state": "NY",
              "postalCode": "10118"
            },
            "owner": {
              "firstName": "Jane",
              "lastName": "Doe",
              "email": "jane.doe@acmesupplies.com",
              "dateOfBirth": "1985-04-12",
              "phoneNumber": "+12125559876"
            }
          }
        },
        "response": {
          "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
          "type": "business",
          "externalId": "partner-biz-1234",
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:00:00Z",
          "name": "Acme Supplies",
          "legalName": "Acme Supplies LLC",
          "businessType": "llc",
          "taxInfo": {
            "type": "ein",
            "identifierLast4": "6789"
          },
          "phoneNumber": "+12125551234",
          "contact": {
            "firstName": "Jane",
            "lastName": "Doe"
          },
          "website": "https://acmesupplies.com",
          "address": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "legalAddress": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "industry": {
            "naicsCode": "424410"
          },
          "owner": {
            "firstName": "Jane",
            "lastName": "Doe",
            "email": "jane.doe@acmesupplies.com"
          }
        },
        "responseFields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Opaque entity id (ent_<uuid>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.identifierLast4",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "errorResponse": {
          "error": {
            "type": "conflict_error",
            "code": "DUPLICATE_ENTITY",
            "message": "Entity already exists; only trusted partners may create additional entities"
          }
        }
      },
      {
        "id": "get-entities-entityid",
        "method": "GET",
        "path": "/v2/entities/{entityId}",
        "name": "Get an entity",
        "auth": "Partner key",
        "summary": "Get an entity",
        "params": [
          {
            "name": "entityId",
            "type": "string",
            "required": true,
            "desc": "An entity id (ent_<uuid>) or the sentinel `me` (the partner's sole entity)."
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/entities/ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d",
          "resource": "entities",
          "action": "retrieve",
          "args": [
            "ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d"
          ]
        },
        "response": {
          "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
          "type": "business",
          "externalId": "partner-biz-1234",
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:00:00Z",
          "name": "Acme Supplies",
          "legalName": "Acme Supplies LLC",
          "businessType": "llc",
          "taxInfo": {
            "type": "ein",
            "identifierLast4": "6789"
          },
          "phoneNumber": "+12125551234",
          "contact": {
            "firstName": "Jane",
            "lastName": "Doe"
          },
          "website": "https://acmesupplies.com",
          "address": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "legalAddress": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "industry": {
            "naicsCode": "424410"
          },
          "owner": {
            "firstName": "Jane",
            "lastName": "Doe",
            "email": "jane.doe@acmesupplies.com"
          }
        },
        "responseFields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Opaque entity id (ent_<uuid>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.identifierLast4",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "patch-entities-entityid",
        "method": "PATCH",
        "path": "/v2/entities/{entityId}",
        "name": "Update an entity's",
        "auth": "Partner key",
        "summary": "Update an entity's (KYC) fields",
        "params": [
          {
            "name": "entityId",
            "type": "string",
            "required": true,
            "desc": "An entity id (ent_<uuid>) or the sentinel `me` (the partner's sole entity)."
          }
        ],
        "fields": [
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "enum",
            "options": [
              "partnership",
              "sole-proprietorship",
              "llc",
              "corporation",
              "trust",
              "non-profit",
              "municipality"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n"
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state code (e.g. NY, CA)."
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.dateOfBirth",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "spec": {
          "method": "PATCH",
          "path": "/v2/entities/ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d",
          "resource": "entities",
          "action": "update",
          "args": [
            "ent_c9d4a1e6-8f3b-4c92-9a1d-2b6e4f5a7c8d"
          ],
          "body": {
            "name": "Acme Supplies Co",
            "website": "https://acme-supplies.example.com",
            "metadata": {
              "crmId": "C-1"
            }
          }
        },
        "response": {
          "id": "ent_7c9e6679-7425-40de-944b-e07fc1f90ae7",
          "type": "business",
          "externalId": "partner-biz-1234",
          "metadata": {
            "crmId": "C-1"
          },
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:10:00Z",
          "name": "Acme Supplies Co",
          "legalName": "Acme Supplies LLC",
          "businessType": "llc",
          "taxInfo": {
            "type": "ein",
            "identifierLast4": "6789"
          },
          "phoneNumber": "+12125551234",
          "contact": {
            "firstName": "Jane",
            "lastName": "Doe"
          },
          "website": "https://acme-supplies.example.com",
          "address": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "legalAddress": {
            "line1": "350 5th Ave",
            "city": "New York",
            "state": "NY",
            "postalCode": "10118",
            "countryCode": "US"
          },
          "industry": {
            "naicsCode": "424410"
          },
          "owner": {
            "firstName": "Jane",
            "lastName": "Doe",
            "email": "jane.doe@acmesupplies.com"
          }
        },
        "responseFields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "business"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "id",
            "type": "string",
            "required": true,
            "desc": "Opaque entity id (ent_<uuid>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "businessType",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.type",
            "type": "enum",
            "options": [
              "ein",
              "ssn",
              "itin"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "taxInfo.identifierLast4",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "phoneNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "contact.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "website",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "address.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line1",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.line2",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.city",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.state",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.postalCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.aptNumber",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "legalAddress.countryCode",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "industry.naicsCode",
            "type": "string",
            "required": true,
            "desc": "NAICS industry classification code (digits)."
          },
          {
            "name": "industry.name",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.firstName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.lastName",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "owner.email",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "get-limitations",
        "method": "GET",
        "path": "/v2/limitations",
        "name": "Get an entity's payment limitations",
        "auth": "Partner key",
        "summary": "Get an entity's payment limitations (per-capability)",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/limitations",
          "resource": "limitations",
          "action": "list",
          "args": []
        },
        "response": {
          "canSendDomesticPayment": {
            "allowed": false,
            "missingFields": [
              "profile.taxInfo"
            ]
          }
        },
        "responseFields": [
          {
            "name": "canSendDomesticPayment.allowed",
            "type": "boolean",
            "required": true,
            "desc": "Whether the business may perform this capability today."
          },
          {
            "name": "canSendDomesticPayment.missingFields",
            "type": "string[]",
            "required": true,
            "desc": "Dot-paths into the Entity wire model that must be completed before this capability is allowed, e.g. \"taxInfo\". Empty when `allowed` is true.\n"
          }
        ]
      }
    ]
  },
  {
    "id": "accounts",
    "label": "Accounts",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-accounts",
        "method": "GET",
        "path": "/v2/accounts",
        "name": "List an entity's accounts",
        "auth": "Partner key",
        "summary": "For each internal Plaid account not yet marked `isVerified`, re-reads its verification status from Plaid before responding.\n",
        "queryParams": [
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "card",
              "domestic-wire",
              "virtual-card"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Return only the account whose `externalId` matches (your own id)."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Filter by metadata key/value pairs, e.g. `metadata[ledgerId]=L-9`. Matches accounts whose metadata contains every supplied pair.\n"
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/accounts",
          "resource": "accounts",
          "action": "list",
          "args": []
        },
        "response": {
          "data": [
            {
              "id": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              "ownershipType": "external",
              "type": "ach",
              "counterPartyName": "Globex Manufacturing",
              "bankAccount": {
                "accountType": "checking",
                "routingNumber": "111000025",
                "accountNumberLast4": "4321"
              },
              "createdAt": "2026-07-08T15:05:00Z",
              "updatedAt": "2026-07-08T15:05:00Z"
            },
            {
              "id": "acct_8be01c32-9378-4aad-9f0d-229e4454259c",
              "ownershipType": "external",
              "type": "check",
              "counterPartyName": "Initech",
              "paperCheck": {
                "printName": "Initech Inc",
                "address": {
                  "line1": "500 Market St",
                  "city": "San Francisco",
                  "state": "CA",
                  "postalCode": "94105"
                }
              },
              "createdAt": "2026-07-08T15:05:15Z",
              "updatedAt": "2026-07-08T15:05:15Z"
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-accounts",
        "method": "POST",
        "path": "/v2/accounts",
        "name": "Create an account",
        "auth": "Partner key or session token",
        "summary": "Accepts the partner api-key, or the scoped session token (Bearer) minted by POST .../accounts/link — the scoped token can only create internal accounts. An internal ACH account submitted with raw account/routing numbers is only allowed for partners approved for raw bank input; otherwise use the Plaid link flow.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          },
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": false,
            "desc": "Unique key (recommended: a UUID) that makes a create request safe to retry. Retrying with the same key replays the original response instead of creating a second resource. Scoped per partner, retained 24h. Reusing a key with a different body returns 409.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed session token issued by the Melio Sonar SDK on the device that initiated the request. When present it is cryptographically verified and its device IP is used for risk evaluation; an invalid or expired token is rejected with 403. Omit it when no SDK session is available.\n"
          }
        ],
        "fields": [
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "domestic-wire",
              "virtual-card"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "nickname",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "bankAccount.accountType",
            "type": "enum",
            "options": [
              "checking",
              "savings"
            ],
            "required": true,
            "desc": "Required when ownershipType=internal, type=ach."
          },
          {
            "name": "bankAccount.accountNumber",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=internal, type=ach."
          },
          {
            "name": "bankAccount.routingNumber",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=internal, type=ach."
          },
          {
            "name": "counterPartyName",
            "type": "string",
            "required": false,
            "desc": "Counterparty name Required when ownershipType=external, type=ach."
          },
          {
            "name": "paperCheck.printName",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=external, type=check."
          },
          {
            "name": "paperCheck.address",
            "type": "object",
            "required": true,
            "desc": "Required when ownershipType=external, type=check."
          },
          {
            "name": "address.line1",
            "type": "string",
            "required": true,
            "desc": "Street address. Must not be a PO box for the business (physical) address.\n Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.line2",
            "type": "string",
            "required": false,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.city",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.state",
            "type": "string",
            "required": true,
            "desc": "Two-letter US state code (e.g. NY, CA). Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.postalCode",
            "type": "string",
            "required": true,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.aptNumber",
            "type": "string",
            "required": false,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "address.countryCode",
            "type": "enum",
            "options": [
              "US"
            ],
            "required": false,
            "desc": "Required when ownershipType=external, type=domestic-wire."
          },
          {
            "name": "counterPartyEmail",
            "type": "string",
            "required": false,
            "desc": "Email the single-use virtual card is delivered to Required when ownershipType=external, type=virtual-card."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/accounts",
          "resource": "accounts",
          "action": "create",
          "args": [],
          "body": {
            "ownershipType": "internal",
            "type": "ach",
            "nickname": "Operating account",
            "bankAccount": {
              "accountType": "checking",
              "accountNumber": "000123456789",
              "routingNumber": "021000021"
            }
          }
        },
        "response": {
          "id": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "ownershipType": "internal",
          "type": "ach",
          "nickname": "Operating account",
          "isVerified": true,
          "bankAccount": {
            "accountType": "checking",
            "routingNumber": "021000021",
            "accountNumberLast4": "6789"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque account id (acct_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "card",
              "domestic-wire",
              "virtual-card"
            ],
            "required": false,
            "desc": "Plaid-backed internal accounts are returned as ach."
          },
          {
            "name": "nickname",
            "type": "string",
            "required": false,
            "desc": "Present for internal accounts."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "errorResponse": {
          "error": {
            "code": "DUPLICATE_EXTERNAL_ID",
            "message": "An account with externalId 'partner-acct-42' already exists."
          }
        }
      },
      {
        "id": "post-accounts-link",
        "method": "POST",
        "path": "/v2/accounts/link",
        "name": "Generate a link for an entity to add a Plaid or…",
        "auth": "Partner key",
        "summary": "Partner-facing (api-key). Returns a short-lived link the partner hands to the entity; opening it lands on the portal, which runs the Plaid/card flow and submits to POST .../accounts using the embedded scoped token. For `plaid`, a Plaid link_token is minted now and embedded in the returned token.\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed session token issued by the Melio Sonar SDK on the device that initiated the request. When present it is cryptographically verified and its device IP is used for risk evaluation; an invalid or expired token is rejected with 403. Omit it when no SDK session is available.\n"
          }
        ],
        "fields": [
          {
            "name": "type",
            "type": "enum",
            "options": [
              "plaid",
              "card"
            ],
            "required": true,
            "desc": ""
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/accounts/link",
          "resource": "accountsLink",
          "action": "create",
          "args": [],
          "body": {
            "type": "plaid"
          }
        },
        "response": {
          "data": {
            "url": "https://portal.melio.com/payouts/link?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
            "expiration": "2026-07-08T16:04:05Z"
          }
        },
        "responseFields": [
          {
            "name": "data.url",
            "type": "string",
            "required": false,
            "desc": "Portal URL the entity opens to add the account (the scoped session JWT is embedded as ?token=)"
          },
          {
            "name": "data.expiration",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "get-accounts-accountid",
        "method": "GET",
        "path": "/v2/accounts/{accountId}",
        "name": "Get an account",
        "auth": "Partner key",
        "summary": "For an internal Plaid account not yet marked `isVerified`, re-reads its verification status from Plaid before responding.\n",
        "params": [
          {
            "name": "accountId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/accounts/acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "resource": "accounts",
          "action": "retrieve",
          "args": [
            "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301"
          ]
        },
        "response": {
          "id": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "ownershipType": "internal",
          "type": "ach",
          "nickname": "Operating account",
          "isVerified": false,
          "bankAccount": {
            "accountType": "checking",
            "routingNumber": "021000021",
            "accountNumberLast4": "6789"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque account id (acct_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "ownershipType",
            "type": "enum",
            "options": [
              "internal",
              "external"
            ],
            "required": false,
            "desc": ""
          },
          {
            "name": "type",
            "type": "enum",
            "options": [
              "ach",
              "check",
              "card",
              "domestic-wire",
              "virtual-card"
            ],
            "required": false,
            "desc": "Plaid-backed internal accounts are returned as ach."
          },
          {
            "name": "nickname",
            "type": "string",
            "required": false,
            "desc": "Present for internal accounts."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "delete-accounts-accountid",
        "method": "DELETE",
        "path": "/v2/accounts/{accountId}",
        "name": "Delete an account",
        "auth": "Partner key",
        "summary": "Delete an account",
        "params": [
          {
            "name": "accountId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "spec": {
          "method": "DELETE",
          "path": "/v2/accounts/acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "resource": "accounts",
          "action": "delete",
          "args": [
            "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301"
          ]
        },
        "response": {},
        "errorResponse": {
          "error": {
            "code": "ACCOUNT_IN_USE",
            "message": "Account cannot be deleted because it is referenced by one or more payments"
          }
        }
      }
    ]
  },
  {
    "id": "payments",
    "label": "Payments",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-payments",
        "method": "GET",
        "path": "/v2/payments",
        "name": "List payments for an entity",
        "auth": "Partner key",
        "summary": "Cursor-paginated, newest-first. Narrow the list with the filter parameters below; they combine with AND and compose with pagination.\n",
        "queryParams": [
          {
            "name": "limit",
            "type": "integer",
            "required": false,
            "desc": "Maximum number of resources to return, 1–50. Defaults to 50."
          },
          {
            "name": "startingAfter",
            "type": "string",
            "required": false,
            "desc": "Cursor for forward (older) pagination: a resource id. The page returned starts immediately after this resource. Mutually exclusive with `endingBefore`.\n"
          },
          {
            "name": "endingBefore",
            "type": "string",
            "required": false,
            "desc": "Cursor for backward (newer) pagination: a resource id. The page returned ends immediately before this resource. Mutually exclusive with `startingAfter`.\n"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Return only the payment whose `externalId` matches (your own id)."
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "Filter by payment status."
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Return only payments drawn from this internal originating account (acct_<id>)."
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "Return only payments sent to this external receiving account (acct_<id>)."
          },
          {
            "name": "created[gte]",
            "type": "string",
            "required": false,
            "desc": "Return payments created at or after this RFC 3339 timestamp."
          },
          {
            "name": "created[lte]",
            "type": "string",
            "required": false,
            "desc": "Return payments created at or before this RFC 3339 timestamp."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Filter by metadata key/value pairs, e.g. `metadata[invoiceId]=INV-42`. Matches payments whose metadata contains every supplied pair.\n"
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/payments",
          "resource": "payments",
          "action": "list",
          "args": []
        },
        "response": {
          "hasMore": true,
          "data": [
            {
              "id": "pay_9f8c7b6a5d4e3f21",
              "externalId": "invoice-2043",
              "amount": 125000,
              "currency": "USD",
              "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
              "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              "deductionDate": "2026-07-10",
              "deliveryDate": "2026-07-14",
              "status": "scheduled",
              "metadata": {
                "invoiceId": "INV-2043",
                "department": "operations"
              },
              "createdAt": "2026-07-08T15:04:05Z",
              "updatedAt": "2026-07-08T15:04:05Z"
            },
            {
              "id": "pay_1a2b3c4d5e6f7a8b",
              "externalId": "invoice-2041",
              "amount": 4200,
              "currency": "USD",
              "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
              "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
              "deductionDate": "2026-07-09",
              "deliveryDate": "2026-07-11",
              "status": "completed",
              "metadata": {},
              "createdAt": "2026-07-07T09:22:00Z",
              "updatedAt": "2026-07-07T09:22:00Z"
            }
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": true,
            "desc": ""
          },
          {
            "name": "hasMore",
            "type": "boolean",
            "required": true,
            "desc": "True when more resources exist after this page; page again using the last item's id as `startingAfter`."
          }
        ]
      },
      {
        "id": "post-payments",
        "method": "POST",
        "path": "/v2/payments",
        "name": "Create a payment",
        "auth": "Partner key",
        "summary": "Create a payment (a bill is auto-created internally)",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          },
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": true,
            "desc": "Required. Unique key (recommended: a UUID) that makes payment creation safe to retry. Retrying with the same key replays the original response instead of creating a second payment. Scoped per partner, retained 24h. Reusing a key with a different body returns 409; omitting it returns 400 IDEMPOTENCY_KEY_REQUIRED.\n"
          },
          {
            "name": "Melio-Sonar-Token",
            "type": "string",
            "required": false,
            "desc": "Signed session token issued by the Melio Sonar SDK on the device that initiated the request. When present it is cryptographically verified and its device IP is used for risk evaluation; an invalid or expired token is rejected with 403. Omit it when no SDK session is available.\n"
          }
        ],
        "fields": [
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Minor units (cents)"
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": "Internal originating account id (acct_<id>) — the debit account"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>) — the credit account"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": true,
            "desc": "Required, and explicit about the receiving rail. Pick the normal-speed value that matches the receiving account's delivery method (`standard-ach`, `standard-check`, `domestic-wire`, `virtual-card`). The faster variants — `same-day-ach` / `rtp` (ach), `express-check` / `overnight-check` (check), `instant-domestic-wire` (domestic-wire), `instant-virtual-card` (virtual-card) — require an ACH originating account and pass a per-payment eligibility check. The preference's rail must match the receiving account's delivery method, otherwise the request is rejected with `400`; a faster variant that is ineligible for the payment is likewise rejected with `400` (never silently downgraded).\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "compliance",
            "type": "object",
            "required": true,
            "desc": "Compliance details, discriminated by `type`. Only `goods-and-services` is supported today; future payment types (internal money movement, mass payouts) will add their own variants with different fields.\n"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/payments",
          "resource": "payments",
          "action": "create",
          "args": [],
          "body": {
            "amount": 125000,
            "currency": "USD",
            "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
            "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            "deductionDate": "2026-07-10",
            "deliveryPreference": "standard-ach",
            "compliance": {
              "type": "goods-and-services"
            },
            "externalId": "invoice-2043",
            "noteToRecipient": "July materials order",
            "metadata": {
              "invoiceId": "INV-2043",
              "department": "operations"
            }
          }
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryDate": "2026-07-14",
          "status": "scheduled",
          "noteToRecipient": "July materials order",
          "metadata": {
            "invoiceId": "INV-2043",
            "department": "operations"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": false,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "A payment under risk review is internal-only and is reported as `scheduled` until the review resolves; partners never see a distinct \"blocked\" state.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "errorResponse": {
          "error": {
            "code": "DUPLICATE_EXTERNAL_ID",
            "message": "A payment with externalId 'invoice-2043' already exists."
          }
        }
      },
      {
        "id": "get-payments-paymentid",
        "method": "GET",
        "path": "/v2/payments/{paymentId}",
        "name": "Get a payment",
        "auth": "Partner key",
        "summary": "`paymentId` is a Melio payment id (`pay_<id>`). To look a payment up by your own identifier instead, list payments with `?externalId=`.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "spec": {
          "method": "GET",
          "path": "/v2/payments/pay_9f8c7b6a5d4e3f21",
          "resource": "payments",
          "action": "retrieve",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ]
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryDate": "2026-07-14",
          "status": "scheduled",
          "metadata": {
            "invoiceId": "INV-2043",
            "department": "operations"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:04:05Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": false,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "A payment under risk review is internal-only and is reported as `scheduled` until the review resolves; partners never see a distinct \"blocked\" state.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "patch-payments-paymentid",
        "method": "PATCH",
        "path": "/v2/payments/{paymentId}",
        "name": "Update a payment before it begins processing",
        "auth": "Partner key",
        "summary": "Update a payment while it is still scheduled. Only allowed while the payment's `status` is `scheduled`; once processing has begun (`in-progress`, `completed`, `failed`, `canceled`) the request returns 409 PAYMENT_NOT_EDITABLE. Only the fields present in the request body are changed; omitted fields keep their current value.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ],
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "fields": [
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": "Minor units (cents). Amount changes may be rejected (400) when the partner is not configured to allow them or when the payment spans multiple bills.\n"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": "The debit/schedule date"
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": false,
            "desc": "See CreatePaymentRequest.deliveryPreference. The preference's rail must match the payment's receiving account; fast variants remain subject to the per-payment eligibility check and are rejected with 400 when ineligible."
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          }
        ],
        "spec": {
          "method": "PATCH",
          "path": "/v2/payments/pay_9f8c7b6a5d4e3f21",
          "resource": "payments",
          "action": "update",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ],
          "body": {
            "deliveryPreference": "rtp",
            "noteToRecipient": "Invoice 42 (updated)",
            "metadata": {
              "invoiceId": "INV-2043"
            }
          }
        },
        "response": {
          "id": "pay_9f8c7b6a5d4e3f21",
          "externalId": "invoice-2043",
          "amount": 125000,
          "currency": "USD",
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deductionDate": "2026-07-10",
          "deliveryPreference": "rtp",
          "deliveryDate": "2026-07-10",
          "status": "scheduled",
          "noteToRecipient": "Invoice 42 (updated)",
          "metadata": {
            "invoiceId": "INV-2043"
          },
          "createdAt": "2026-07-08T15:04:05Z",
          "updatedAt": "2026-07-08T15:12:00Z"
        },
        "responseFields": [
          {
            "name": "id",
            "type": "string",
            "required": false,
            "desc": "Opaque payment id (pay_<id>)"
          },
          {
            "name": "externalId",
            "type": "string",
            "required": false,
            "desc": "Your own unique identifier for the resource. Unique per partner per resource type (reusing one returns 409 DUPLICATE_EXTERNAL_ID). Distinct from the Idempotency-Key header, which dedupes the request rather than identifying the resource.\n"
          },
          {
            "name": "amount",
            "type": "integer",
            "required": false,
            "desc": ""
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": false,
            "desc": "Internal originating account id (acct_<id>)"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": false,
            "desc": "External receiving account id (acct_<id>)"
          },
          {
            "name": "deductionDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": false,
            "desc": "Effective delivery preference. Reflects the faster variant when one was applied, otherwise the receiving rail's normal-speed value.\n"
          },
          {
            "name": "deliveryDate",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "status",
            "type": "enum",
            "options": [
              "scheduled",
              "in-progress",
              "completed",
              "failed",
              "canceled"
            ],
            "required": false,
            "desc": "A payment under risk review is internal-only and is reported as `scheduled` until the review resolves; partners never see a distinct \"blocked\" state.\n"
          },
          {
            "name": "noteToSelf",
            "type": "string",
            "required": false,
            "desc": "Payer-private memo, never shown to the recipient"
          },
          {
            "name": "noteToRecipient",
            "type": "string",
            "required": false,
            "desc": "Note shown to the payment recipient"
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Free-form string key/value pairs stored and returned verbatim, never interpreted by Melio. Up to 50 keys; each key 1–40 chars and may not contain square brackets (`[` `]`, reserved for the `metadata[key]` filter); value ≤100 chars. Filterable via `metadata[key]`.\n"
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "post-simulations-payments-paymentid-actions",
        "method": "POST",
        "path": "/v2/simulations/payments/{paymentId}/actions",
        "name": "Simulate a payment lifecycle transition",
        "auth": "Partner key",
        "badge": "Sandbox only",
        "summary": "Advances a payment through its lifecycle for testing: approve or decline the risk review, collect or deliver the funds, or simulate a collection/delivery failure. The action is applied against the real payment, so the resulting status change and any webhooks fire exactly as they would in production. Non-production environments only.\n",
        "params": [
          {
            "name": "paymentId",
            "type": "string",
            "required": true,
            "desc": "A payment id (pay_<id>)."
          }
        ],
        "headerParams": [
          {
            "name": "Idempotency-Key",
            "type": "string",
            "required": false,
            "desc": "Unique key (recommended: a UUID) that makes a create request safe to retry. Retrying with the same key replays the original response instead of creating a second resource. Scoped per partner, retained 24h. Reusing a key with a different body returns 409.\n"
          }
        ],
        "fields": [
          {
            "name": "action",
            "type": "enum",
            "options": [
              "risk-approve",
              "risk-decline",
              "collect",
              "deliver",
              "fail-collect",
              "fail-deliver"
            ],
            "required": true,
            "desc": "The payment lifecycle transition to simulate."
          },
          {
            "name": "metadata",
            "type": "object",
            "required": false,
            "desc": "Optional metadata echoed to logs; not persisted on the payment."
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/simulations/payments/pay_9f8c7b6a5d4e3f21/actions",
          "resource": "simulationsPaymentsActions",
          "action": "create",
          "args": [
            "pay_9f8c7b6a5d4e3f21"
          ],
          "body": {
            "action": "risk-approve"
          }
        },
        "response": {}
      }
    ]
  },
  {
    "id": "webhooks",
    "label": "Webhooks",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-webhook",
        "method": "GET",
        "path": "/v2/webhook",
        "name": "Get the authenticated partner's webhook endpoint",
        "auth": "Partner key",
        "summary": "Get the authenticated partner's webhook endpoint",
        "spec": {
          "method": "GET",
          "path": "/v2/webhook",
          "resource": "webhook",
          "action": "list",
          "args": []
        },
        "response": {
          "url": "https://partner.example.com/webhooks/melio",
          "description": "Production endpoint",
          "events": [
            "api.entity.created",
            "api.account.updated"
          ],
          "isActive": true,
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:00:00Z"
        },
        "responseFields": [
          {
            "name": "url",
            "type": "string",
            "required": true,
            "desc": "The https endpoint deliveries are POSTed to."
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "events",
            "type": "object[]",
            "required": true,
            "desc": ""
          },
          {
            "name": "isActive",
            "type": "boolean",
            "required": true,
            "desc": "When false, deliveries to this endpoint are paused."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "patch-webhook",
        "method": "PATCH",
        "path": "/v2/webhook",
        "name": "Create or update the partner's webhook endpoint",
        "auth": "Partner key",
        "summary": "Configure the single webhook endpoint for the authenticated partner. Only the fields present in the request body are changed; omitted fields keep their current value. On first configuration `url` and `events` are required. Providing `events` replaces the full subscription list (send at least one). Each delivery is signed with HMAC-SHA256 in the `X-Melio-Signature` header (see Verifying signatures).\n",
        "fields": [
          {
            "name": "url",
            "type": "string",
            "required": false,
            "desc": "https endpoint that will receive deliveries."
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "events",
            "type": "object[]",
            "required": false,
            "desc": "Event types to subscribe to. When provided, replaces the current list (at least one)."
          },
          {
            "name": "isActive",
            "type": "boolean",
            "required": false,
            "desc": ""
          }
        ],
        "spec": {
          "method": "PATCH",
          "path": "/v2/webhook",
          "resource": "webhook",
          "action": "update",
          "args": [],
          "body": {
            "url": "https://partner.example.com/webhooks/melio",
            "description": "Production endpoint",
            "events": [
              "api.entity.created",
              "api.account.updated"
            ]
          }
        },
        "response": {
          "url": "https://partner.example.com/webhooks/melio",
          "description": "Production endpoint",
          "events": [
            "api.entity.created",
            "api.account.updated"
          ],
          "isActive": true,
          "createdAt": "2026-07-08T15:00:00Z",
          "updatedAt": "2026-07-08T15:00:00Z"
        },
        "responseFields": [
          {
            "name": "url",
            "type": "string",
            "required": true,
            "desc": "The https endpoint deliveries are POSTed to."
          },
          {
            "name": "description",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "events",
            "type": "object[]",
            "required": true,
            "desc": ""
          },
          {
            "name": "isActive",
            "type": "boolean",
            "required": true,
            "desc": "When false, deliveries to this endpoint are paused."
          },
          {
            "name": "createdAt",
            "type": "string",
            "required": false,
            "desc": ""
          },
          {
            "name": "updatedAt",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ]
      },
      {
        "id": "delete-webhook",
        "method": "DELETE",
        "path": "/v2/webhook",
        "name": "Delete the partner's webhook endpoint",
        "auth": "Partner key",
        "summary": "Delete the partner's webhook endpoint",
        "spec": {
          "method": "DELETE",
          "path": "/v2/webhook",
          "resource": "webhook",
          "action": "delete",
          "args": []
        },
        "response": {}
      },
      {
        "id": "get-webhook-events",
        "method": "GET",
        "path": "/v2/webhook/events",
        "name": "List the event types available for subscription",
        "auth": "Partner key",
        "summary": "List the event types available for subscription",
        "spec": {
          "method": "GET",
          "path": "/v2/webhook/events",
          "resource": "webhookEvents",
          "action": "list",
          "args": []
        },
        "response": {
          "data": [
            "api.entity.created",
            "api.entity.updated",
            "api.account.created",
            "api.account.updated",
            "api.account.deleted",
            "api.payment.created",
            "api.payment.updated"
          ]
        },
        "responseFields": [
          {
            "name": "data",
            "type": "object[]",
            "required": false,
            "desc": ""
          }
        ]
      }
    ]
  },
  {
    "id": "health",
    "label": "Health",
    "kind": "resource",
    "endpoints": [
      {
        "id": "get-health",
        "method": "GET",
        "path": "/v2/health",
        "name": "Verify your base URL and api-key are valid",
        "auth": "Partner key",
        "summary": "Confirms the request reached the right environment and the api-key authenticates successfully. Useful as a first call when wiring up an integration.\n",
        "spec": {
          "method": "GET",
          "path": "/v2/health",
          "resource": "health",
          "action": "list",
          "args": []
        },
        "response": {
          "status": "ok",
          "partnerName": "acme-supplies"
        },
        "responseFields": [
          {
            "name": "status",
            "type": "enum",
            "options": [
              "ok"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "partnerName",
            "type": "string",
            "required": true,
            "desc": ""
          }
        ]
      }
    ]
  },
  {
    "id": "fees",
    "label": "Fees",
    "kind": "resource",
    "endpoints": [
      {
        "id": "post-tools-fee-calculator",
        "method": "POST",
        "path": "/v2/tools/fee-calculator",
        "name": "Calculate the fees for a prospective payment",
        "auth": "Partner key",
        "summary": "A standalone tool that estimates the fees for a payment between two of an entity's accounts, without creating a payment. The entity is supplied via the `Melio-Entity-Id` header and both accounts in the request body. Fees depend on the originating funding source, the receiving delivery method, the requested `deliveryPreference`, and the payment `amount`. All monetary values in the request and response are minor units (cents).\n",
        "headerParams": [
          {
            "name": "Melio-Entity-Id",
            "type": "string",
            "required": true,
            "desc": "The entity this request operates on: an entity id (`ent_<uuid>`) or the sentinel `me` (the partner's sole entity). Supplied as a header so account, payment, and limitation resources are addressed at the top level instead of being nested under the entity path.\n"
          }
        ],
        "fields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": "Internal originating account id (acct_<id>) — the debit account"
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": "External receiving account id (acct_<id>) — the credit account"
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": true,
            "desc": "The delivery preference to price. Its rail must match the receiving account; the normal-speed values (`standard-ach`, `standard-check`, `domestic-wire`, `virtual-card`) price that rail at normal speed."
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "The payment amount to price, in minor units (cents)."
          },
          {
            "name": "currency",
            "type": "string",
            "required": false,
            "desc": ""
          }
        ],
        "spec": {
          "method": "POST",
          "path": "/v2/tools/fee-calculator",
          "resource": "toolsFeeCalculator",
          "action": "create",
          "args": [],
          "body": {
            "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
            "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
            "deliveryPreference": "same-day-ach",
            "amount": 125000
          }
        },
        "response": {
          "originatingAccountId": "acct_3f2504e0-4f89-41d3-9a0c-0305e82c3301",
          "receivingAccountId": "acct_9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d",
          "deliveryPreference": "same-day-ach",
          "amount": 125000,
          "currency": "USD",
          "fees": [
            {
              "type": "expedited-ach",
              "percent": {
                "rate": 0.5,
                "cap": 3000
              },
              "amount": 625
            }
          ],
          "totalFee": 625
        },
        "responseFields": [
          {
            "name": "originatingAccountId",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "receivingAccountId",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "deliveryPreference",
            "type": "enum",
            "options": [
              "standard-ach",
              "same-day-ach",
              "rtp",
              "standard-check",
              "express-check",
              "overnight-check",
              "domestic-wire",
              "instant-domestic-wire",
              "virtual-card",
              "instant-virtual-card"
            ],
            "required": true,
            "desc": ""
          },
          {
            "name": "amount",
            "type": "integer",
            "required": true,
            "desc": "Echoes the requested payment amount, minor units (cents)."
          },
          {
            "name": "currency",
            "type": "string",
            "required": true,
            "desc": ""
          },
          {
            "name": "fees",
            "type": "object[]",
            "required": true,
            "desc": ""
          },
          {
            "name": "totalFee",
            "type": "integer",
            "required": false,
            "desc": "Sum of all fees, minor units (cents). Present unless a fee could not be resolved to an `amount` (e.g. tiered pricing).\n"
          }
        ]
      }
    ]
  }
];

// Spec-sourced metadata for the overview hero (version pills, server list, auth description).
// Any field the spec doesn't declare is simply absent — consumers must render nothing rather
// than fall back to invented copy.
export const API_META: {
  version?: string;
  oasVersion?: string;
  servers?: { url: string; description?: string }[];
  authDescription?: string;
} = {
  "version": "1.0",
  "oasVersion": "3.0.3",
  "servers": [
    {
      "description": "Production",
      "url": "https://api.melio.com/v2"
    }
  ]
};
